// console.log('main.js')

import sketches2016 from './sketches2016.json'
import sketches2017 from './sketches2017.json'
import sketches2018 from './sketches2018.json'
import sketches2019 from './sketches2019.json'



function addHtmlToElement( el, html) {
  return el.insertAdjacentHTML('beforeend', html);
}

function getLink( url ){
  var name = url.split('/').pop()
  return `<div><a href="${url}/index.html" target="_blank">${name}</a></div>`
}


sketches2019.reverse().forEach( ( url ) => {
  addHtmlToElement(year2019, getLink( url ))
});

sketches2018.reverse().forEach( ( url ) => {
  addHtmlToElement(year2018, getLink( url ))
});

sketches2017.reverse().forEach( ( url ) => {
  addHtmlToElement(year2017, getLink( url ))
});

sketches2016.reverse().forEach( ( url ) => {
  addHtmlToElement(year2016, getLink( url ))
});
